<template>
    <eSesjaModal class="export-sms">
        <eSesjaModalHeader @close="$store.commit('setExportRegistryModalStatus', false)">
            {{$t('com.file.export-registry-modal.export-registry')}}
        </eSesjaModalHeader>
        <eSesjaModalBody class="d-flex flex-column gap-3">
            <section class="d-flex flex-grow-1 gap-3">
                <section class="d-flex flex-column flex-grow-1 gap-1">
                    <SearchLabelComponent :label="$t('com.global.date-from')" />
                    <SearchInputDateComponent v-model="model.minDate" />
                </section>
                <section class="d-flex flex-column flex-grow-1 gap-1">
                    <SearchLabelComponent :label="$t('com.global.date-to')" />
                    <SearchInputDateComponent v-model="model.maxDate" />
                </section>
            </section>
            <section class="d-flex flex-grow-1 gap-3">
                <section class="d-flex flex-column flex-grow-1 gap-1">
                    <SearchLabelComponent :label="$t('com.file.export-registry-modal.group')" />
                    <SearchSelectComponent v-model="selectedGroups" :options="availableGroups"
                                           :placeholder="$t('com.file.announcements.select-group') + '...'" style="width: 100%;" />
                </section>
                <section class="d-flex flex-column flex-grow-1 gap-1">
                    <SearchLabelComponent :label="$t('com.global.session')" />
                    <SearchSelectComponent v-model="selectedSession" :options="availableSessions"
                                           :placeholder="$t('com.file.select-session-modal.select-session') + '...'" style="width: 100%;" />
                </section>
                <section class="d-flex flex-column flex-grow-1 gap-1">
                    <SearchLabelComponent :label="$t('com.file.register.sort-by-session-asc')" />
                    <SearchCheckboxComponent v-model="model.orderAsc" />
                </section>
            </section>
            <section class="d-flex flex-column gap-1">
                <SearchLabelComponent :label="$t('com.file.export-email-modal.file-format')" />
                <SearchSelectComponent v-model="formatOptions.selected" :options="formatOptions.available" style="width: 100%;" />
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$store.commit('setExportRegistryModalStatus', false)">
                {{$t('com.global.cancel')}}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="saveData" :disabled="formatOptions.selected.value === null">
                {{$t('com.global.download')}}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
// components
import SearchLabelComponent from "@/components/BasicControls/SearchLabelComponent.vue";
import SearchInputDateComponent from "@/components/BasicControls/SearchInputDateComponent.vue";
import SearchSelectComponent from "@/components/BasicControls/SearchSelectComponent.vue"; 
import SearchCheckboxComponent from "@/components/BasicControls/SearchCheckboxComponent.vue";

// services
import RegisterService from "@/services/register.service";
import alertsHelper from "@/helpers/alerts.helper";

// helpers
import { fileDownloadHelper } from "@/helpers/file.download.helper";

export default {
    name: "ExportRegistryModal",
    components: {
        SearchLabelComponent,
        SearchInputDateComponent,
        SearchSelectComponent,
        SearchCheckboxComponent,
    },
    props:{
        availableGroups:{
            type: Array,
            default: () => []
        },
        availableSessions:{
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            model: {
                minDate: null,
                maxDate: null,
                format: null,
                groupId: null,
                sessionId: null,
                orderAsc: false
            },

            formatOptions: {
                selected: { value: 0, label: "Microsoft Word (.docx)" },
                available: [
                    { value: 0, label: "Microsoft Word (.docx)" },
                    { value: 10, label: "Microsoft Excel (.xlsx)" }
                ]
            },
            selectedGroups: this.availableGroups[0],
            selectedSession: { value: null, label: this.$t('com.file.select-session-modal.select-session') + "..."}
        }
    },
    methods: {
        async saveData() {
            try {
                this.$store.commit("showLoader");
                this.model.format = this.formatOptions.selected.value;
                this.model.groupId = this.selectedGroups.value;
                this.model.sessionId = this.selectedSession.value;

                const response = await RegisterService.exportRegistry(this.model);

                if (response.status !== 200) {
                    throw await Promise.reject(response)
                }

                fileDownloadHelper(response);
                this.$store.commit('setExportRegistryModalStatus', false);
                this.$swal(alertsHelper.successAlert(this.$t('com.file.export-email-modal.file-downloades-success'), this.$t('com.global.success')));
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.$store.commit("hideLoader");
            }
        }
    }
}
</script>
<style lang="scss">
.export-sms {
    .esesja-search-component-date__input {
        width: 100%;
    }

    .esesja-search-component-select__control {
        width: 100%;
    }
}
</style>